import { light } from '@mui/material/styles/createPalette'
import { InputLabelOverride } from './ThemeOverride'

export const culversStyle = {
  components: InputLabelOverride,
  palette: {
    type: 'light',
    primary: {
      main: '#003366',
      dark: '#002347',
      light: '#335b84',
      contrastText: '#f9f9f9',
    },
    secondary: {
      main: '#3EB4E1',
      dark: '#2b7d9d',
      light: '#64c3e7',
      contrastText: '#f9f9f9',
    },
    white: {
      main: '#FFFFFF',
      dark: '#FFFFFF',
      light: '#FFFFFF',
      contrastText: '#222222',
    },
    storelist: {
      main: '#222222',
    },
    header: {
      main: '#003366',
      highlight: 'white',
    },
    background: {
      default: '#eeeeef',
    },
  },
  typography: {
    fontFamily: `"Roboto", "Courier New", "Helvetica", "Arial", sans-serif`,
    body1: {
      fontFamily: `"Roboto", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h1: {
      fontFamily: `"Culvers Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h2: {
      fontFamily: `"Culvers Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h3: {
      fontFamily: `"Culvers Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h4: {
      fontFamily: `"Culvers Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h5: {
      fontFamily: `"Culvers Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h6: {
      fontFamily: `"Culvers Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        '&$completed': {
          color: '#4caf50CC',
        },
        '&$active': {
          color: '#003366',
        },
      },
      active: {},
      completed: {},
    },
  },
  logo: {
    image: 'culverslogo.png',
  },
}

export const bkStyle = {
  components: InputLabelOverride,
  palette: {
    type: 'light',
    primary: {
      main: '#502314',
      dark: '#613a20',
      light: '#a27658',
      contrastText: '#F5EBDC',
    },
    secondary: {
      main: '#FF8732',
      dark: '#FFAA00',
      light: '#f7b933',
      contrastText: '#222',
    },
    white: {
      main: '#FFFFFF',
      dark: '#FFFFFF',
      light: '#FFFFFF',
      contrastText: '#222222',
    },
    header: {
      main: '#502314',
      highlight: 'white',
      indicator: '#F5EBDC',
    },
    storelist: {
      main: '#222',
    },
    background: {
      default: '#eeeeef',
    },
  },
  typography: {
    fontFamily: `"Roboto", "Courier New", "Helvetica", "Arial", sans-serif`,
    body1: {
      fontFamily: `"Roboto", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h1: {
      fontFamily: `"BK Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h2: {
      fontFamily: `"BK Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h3: {
      fontFamily: `"BK Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h4: {
      fontFamily: `"BK Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h5: {
      fontFamily: `"BK Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h6: {
      fontFamily: `"BK Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        '&$completed': {
          color: '#4caf50CC',
        },
        '&$active': {
          color: '#8b542f',
        },
      },
      active: {},
      completed: {},
    },
  },
  logo: {
    image: 'bk.png',
  },
}

export const thStyle = {
  components: InputLabelOverride,
  palette: {
    type: 'light',
    primary: {
      main: '#C8102E',
      dark: '#8c0b20',
      light: '#d33f57',
      contrastText: '',
    },
    secondary: {
      main: '#3F2021',
      dark: '#3c1f1f',
      light: '#DDCBA4',
      contrastText: '',
    },
    tertiary: {
      main: '#ffffff',
      dark: '#ffffff',
      light: '#ffffff',
      contrastText: '#222222',
    },
    white: {
      main: '#FFFFFF',
      dark: '#FFFFFF',
      light: '#FFFFFF',
      contrastText: '#222222',
    },
    header: {
      main: '#C8102E',
      highlight: 'white',
      weight: 100,
    },
    storelist: {
      main: '#222',
    },
    background: {
      default: '#eeeeef',
    },
  },
  typography: {
    fontFamily: `"Roboto", "Courier New", "Helvetica", "Arial", sans-serif`,
    body1: {
      fontFamily: `"Roboto", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h1: {
      fontFamily: `"TH Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h2: {
      fontFamily: `"TH Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h3: {
      fontFamily: `"TH Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h4: {
      fontFamily: `"TH Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h5: {
      fontFamily: `"TH Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h6: {
      fontFamily: `"TH Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        '&$completed': {
          color: '#4caf50CC',
        },
        '&$active': {
          color: '#C8102E',
        },
      },
      active: {},
      completed: {},
    },
  },
  logo: {
    image: 'th.png',
  },
}

export const krystalStyle = {
  components: InputLabelOverride,
  palette: {
    type: 'light',
    primary: {
      main: '#f4b02a',
      dark: '#aa7b1d',
      light: '#f6bf54',
      contrastText: '',
    },
    secondary: {
      main: '#ce1e30',
      dark: '#901521',
      light: '#d74b59',
      contrastText: '',
    },
    white: {
      main: '#FFFFFF',
      dark: '#FFFFFF',
      light: '#FFFFFF',
      contrastText: '#222222',
    },
    header: {
      main: '#ce1e30',
      highlight: 'white',
    },
    storelist: {
      main: '#222',
    },
    background: {
      default: '#eeeeef',
    },
  },
  typography: {
    fontFamily: `"Roboto", "Courier New", "Helvetica", "Arial", sans-serif`,
    body1: {
      fontFamily: `"Roboto", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h1: {
      fontFamily: `"Krystal Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h2: {
      fontFamily: `"Krystal Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h3: {
      fontFamily: `"Krystal Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h4: {
      fontFamily: `"Krystal Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h5: {
      fontFamily: `"Krystal Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h6: {
      fontFamily: `"Krystal Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        '&$completed': {
          color: '#4caf50CC',
        },
        '&$active': {
          color: '#f4b02a',
        },
      },
      active: {},
      completed: {},
    },
  },
  logo: {
    image: 'krystal.png',
  },
}

export const popeyesStyle = {
  components: InputLabelOverride,
  palette: {
    type: 'light',
    contrastThreshold: 2.5,
    primary: {
      main: '#F25600',
      //#FFA44C
      dark: '#F25600',
      light: '#FF7D00',
    },
    secondary: {
      main: '#00B2A9',
      dark: '#008E87',
      light: '#4CC9C2',
    },
    tertiary: {
      main: '#ffffff',
      dark: '#ffffff',
      light: '#ffffff',
      contrastText: '#222222',
    },
    white: {
      main: '#FFFFFF',
      dark: '#FFFFFF',
      light: '#FFFFFF',
      contrastText: '#222222',
    },
    header: {
      main: '#F25600',
      highlight: 'white',
      weight: 100,
    },
    storelist: {
      main: '#222',
    },
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: `"Roboto", "Courier New", "Helvetica", "Arial", sans-serif`,
    body1: {
      fontFamily: `"Roboto", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h1: {
      fontFamily: `"Popeyes Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h2: {
      fontFamily: `"Popeyes Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h3: {
      fontFamily: `"Popeyes Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h4: {
      fontFamily: `"Popeyes Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h5: {
      fontFamily: `"Popeyes Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h6: {
      fontFamily: `"Popeyes Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        '&$completed': {
          color: '#4caf50CC',
        },
        '&$active': {
          color: '#FF7D00',
        },
      },
      active: {},
      completed: {},
    },
  },
  logo: {
    image: 'popeyes.png',
  },
}

export const firehousesubsStyle = {
  components: InputLabelOverride,
  palette: {
    type: 'light',
    primary: {
      main: '#C40000',
      dark: '#820000',
      light: '#FF2800',
      contrastText: '#F8F0E4',
    },
    secondary: {
      main: '#E0A52E',
      dark: '#996A00',
      light: '#EDBF62',
      contrastText: '#2D373C',
    },
    white: {
      main: '#FFFFFF',
      dark: '#FFFFFF',
      light: '#FFFFFF',
      contrastText: '#222222',
    },
    header: {
      main: '#C40000',
      highlight: 'white',
    },
    storelist: {
      main: '#222',
    },
    background: {
      default: '#eeeeef',
    },
  },
  typography: {
    fontFamily: `"Roboto", "Courier New", "Helvetica", "Arial", sans-serif`,
    body1: {
      fontFamily: `"Roboto", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h1: {
      fontFamily: `"FHS Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h2: {
      fontFamily: `"FHS Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h3: {
      fontFamily: `"FHS Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h4: {
      fontFamily: `"FHS Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h5: {
      fontFamily: `"FHS Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
    h6: {
      fontFamily: `"FHS Header", "Courier New", "Helvetica", "Arial", sans-serif`,
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        '&$completed': {
          color: '#4caf50CC',
        },
        '&$active': {
          color: '#C40000',
        },
      },
      active: {},
      completed: {},
    },
  },
  logo: {
    image: 'firehousesubs.png',
  },
}

export const devStyle = {
  components: InputLabelOverride,
  palette: {
    primary: {
      main: '#222222',
      dark: '#181818',
      light: '#3A3A3A',
      contrastText: '',
    },
    secondary: {
      main: '#26A69A',
      dark: '#2B6863',
      light: '#62BEB5',
      contrastText: '',
    },
    white: {
      main: '#FFFFFF',
      dark: '#FFFFFF',
      light: '#FFFFFF',
      contrastText: '#222222',
    },
    header: {
      main: '#222222',
      highlight: 'white',
    },
    success: {
      main: '#4caf50',
      dark: '#2e7d32',
      light: '#5fde65',
    },
    warning: {
      main: '#ffea00',
      dark: '#c7b800',
      light: '#ffff56',
      contrastText: '#000',
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        '&$completed': {
          color: '#4caf50CC',
        },
        '&$active': {
          color: '#222222',
        },
      },
      active: {},
      completed: {},
    },
  },
  logo: {
    image: 'SerigraphS.png',
  },
}

export const demoStyle = {
  components: InputLabelOverride,
  palette: {
    primary: {
      main: '#0E2133',
      dark: '#0E2133',
      light: '#0E2133',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#A9BB4F',
      dark: '#A9BB4F',
      light: '#A9BB4F',
      contrastText: '',
    },
    white: {
      main: '#FFFFFF',
      dark: '#FFFFFF',
      light: '#FFFFFF',
      contrastText: '#222222',
    },
    success: {
      main: '#4caf50',
      dark: '#2e7d32',
      light: '#5fde65',
    },
    warning: {
      main: '#ffea00',
      dark: '#c7b800',
      light: '#ffff56',
      contrastText: '#000',
    },
    header: {
      main: '#0E2133',
      highlight: 'white',
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        '&$completed': {
          color: '#4caf50CC',
        },
        '&$active': {
          color: '#222222',
        },
      },
      active: {},
      completed: {},
    },
  },
  logo: {
    image: 'BigKahunaLogo.png',
    image2: 'BigKahunaText.png',
  },
  home: {
    layout: 1,
  },
}
